import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { RouteParams } from "shared/api/types/society/[societyId]/app-route-config";
import { useCustomRouter } from "shared/context/CustomRouterContext";
import { AppRouteConfigView } from "shared/mappers/database/app-route/app-route-config/app-route-config";
import { determinParamType } from "hub/src/context/UserHubCustomRouterProvider";

export interface HubRouteConfig<RP = RouteParams>
  extends Partial<Omit<AppRouteConfigView, "routeParams">> {
  routeParams?: RP;
}

type RouteConfigWrapperProps = {
  children: React.ReactNode;
  routeConfig?: Partial<AppRouteConfigView>;
};

export const RouteConfigWrapper = ({
  children,
  routeConfig,
}: RouteConfigWrapperProps) => {
  const router = useCustomRouter();
  const dynamicParams = useParams<{ [key: string]: string }>();

  const mergedRouteParams = useMemo(() => {
    const returnObject = {
      ...(router.state || {}),
      ...Object.entries(dynamicParams).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [key]: determinParamType(value),
        }),
        {},
      ),
      ...routeConfig?.routeParams,
    };
    return returnObject;
  }, [
    routeConfig,
    router.state,
    dynamicParams,
    JSON.stringify({
      routeConfig,
      "router.state": router.state,
      dynamicParams,
    }),
  ]);
  return React.cloneElement(children as React.ReactElement<HubRouteConfig>, {
    ...routeConfig,
    routeParams: mergedRouteParams,
  });
};

export default RouteConfigWrapper;
